
export default function contactPopup () {
    const contactPopup = document.querySelector('.popup--contact');

    if ( !contactPopup ) return;
    if ( document.querySelectorAll('.contact-form__message--success').length > 1 ) return;

    document.addEventListener('DOMContentLoaded', function () {
        if ( contactPopup.querySelector('.contact-form__message--success') ) {
            contactPopup.showPopover();

            window.setTimeout(() => {
                contactPopup.hidePopover();
            }, 3000);
        }
    })
}
